export enum QemDisplayType {
  dialogConfirm = 1,
  immediateSend = 2,
}
